<div class="menu-item-inventory">
  @if (hasEstablishments()) {
    <div class="inventory-controls">
      @if (establishments().length > 1) {
        <p-select
          optionLabel="name"
          optionValue="id"
          [options]="establishments()"
          [ngModel]="selectedEstablishmentId()"
          (ngModelChange)="selectedEstablishmentId.set($event)"
        ></p-select>
      } @else {
        <span class="single-establishment">{{ establishments()[0]?.name }}</span>
      }
      <p-datepicker
        dateFormat="yy-mm-dd"
        [showIcon]="true"
        [ngModel]="selectedDate()"
        (ngModelChange)="selectedDate.set($event)"
      ></p-datepicker>
    </div>

    <p class="window-hint">Showing the selected day and the three days before and after it.</p>

    @if (loadFailed()) {
      <p-message severity="error" text="Couldn't load inventory for this establishment. Please try again."></p-message>
    }

    <p-table [value]="rows()" [loading]="isLoading()" [tableStyle]="{ 'min-width': '40rem' }">
      <ng-template pTemplate="header">
        <tr>
          <th>Date</th>
          <th>Remaining</th>
          <th>Held</th>
          <th>Committed</th>
          <th>Capacity</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr [class.selected-day]="row.isSelected" [class.muted-day]="!row.isSelected">
          <td>{{ row.stockDate }}</td>
          @if (row.hasRow) {
            <td>
              <p-tag [value]="row.stock" [severity]="row.stock > 0 ? 'success' : 'danger'"></p-tag>
            </td>
            <td>{{ row.held }}</td>
            <td>{{ row.committed }}</td>
            <td>{{ row.capacity }}</td>
          } @else {
            <td class="no-row">—</td>
            <td class="no-row">—</td>
            <td class="no-row">—</td>
            <td class="no-row">—</td>
          }
        </tr>
      </ng-template>
    </p-table>
  } @else {
    <p class="empty-state">This item isn't offered by any establishment yet.</p>
  }
</div>
